var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.121 36H0L4.49082 11.1761H6.32555V8.28537C6.32555 3.71821 10.0163 0 14.5605 0C16.7579 0 18.8273 0.870448 20.3847 2.42866C21.3234 3.38507 22.0381 4.56716 22.4221 5.84597L20.5341 6.44776C20.2354 5.4591 19.702 4.56716 18.9767 3.83642C17.8033 2.64358 16.2352 1.99881 14.5605 1.99881C11.1151 1.99881 8.30962 4.82507 8.30962 8.28537V11.1761H24.6302L29.121 36Z",
    fill: "url(#paint0_linear_8678_28458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2357 35.3233H0.885376L5.10952 12.0254H24.0115L28.2357 35.3233Z",
    fill: "url(#paint1_linear_8678_28458)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85088 10.8858H6.78418V8.37114C6.78418 4.05114 10.2723 0.537109 14.5605 0.537109C16.6405 0.537109 18.5926 1.35383 20.054 2.82606C20.726 3.50308 21.2594 4.27681 21.6434 5.14726L20.6727 5.58786C20.342 4.84636 19.8726 4.16935 19.2966 3.58905C18.0272 2.31024 16.3418 1.61174 14.5498 1.61174C10.8483 1.61174 7.84022 4.64218 7.84022 8.37114V10.8858H7.85088Z",
    fill: "url(#paint2_linear_8678_28458)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24288 14.0885C7.66705 14.0885 8.01091 13.7421 8.01091 13.3147C8.01091 12.8874 7.66705 12.541 7.24288 12.541C6.81871 12.541 6.47485 12.8874 6.47485 13.3147C6.47485 13.7421 6.81871 14.0885 7.24288 14.0885Z",
    fill: "url(#paint3_linear_8678_28458)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24291 13.9282C7.57871 13.9282 7.85093 13.654 7.85093 13.3157C7.85093 12.9774 7.57871 12.7031 7.24291 12.7031C6.90711 12.7031 6.63489 12.9774 6.63489 13.3157C6.63489 13.654 6.90711 13.9282 7.24291 13.9282Z",
    fill: "url(#paint4_linear_8678_28458)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90562 12.8993L6.85889 12.9434L7.58774 13.728L7.63447 13.684L6.90562 12.8993Z",
    fill: "url(#paint5_linear_8678_28458)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65701 12.9768L7.61328 12.9297L6.83441 13.664L6.87815 13.711L7.65701 12.9768Z",
    fill: "url(#paint6_linear_8678_28458)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3447 14.0885C21.7689 14.0885 22.1127 13.7421 22.1127 13.3147C22.1127 12.8874 21.7689 12.541 21.3447 12.541C20.9205 12.541 20.5767 12.8874 20.5767 13.3147C20.5767 13.7421 20.9205 14.0885 21.3447 14.0885Z",
    fill: "url(#paint7_linear_8678_28458)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3447 13.9282C21.6805 13.9282 21.9527 13.654 21.9527 13.3157C21.9527 12.9774 21.6805 12.7031 21.3447 12.7031C21.0089 12.7031 20.7367 12.9774 20.7367 13.3157C20.7367 13.654 21.0089 13.9282 21.3447 13.9282Z",
    fill: "url(#paint8_linear_8678_28458)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 12.8954L20.953 12.9395L21.6819 13.7241L21.7286 13.68L20.9997 12.8954Z",
    fill: "url(#paint9_linear_8678_28458)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7513 12.9787L21.7075 12.9316L20.9287 13.6659L20.9724 13.713L21.7513 12.9787Z",
    fill: "url(#paint10_linear_8678_28458)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4863 34.8072C26.9105 34.8072 27.2543 34.4608 27.2543 34.0335C27.2543 33.6062 26.9105 33.2598 26.4863 33.2598C26.0621 33.2598 25.7183 33.6062 25.7183 34.0335C25.7183 34.4608 26.0621 34.8072 26.4863 34.8072Z",
    fill: "url(#paint11_linear_8678_28458)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4863 34.647C26.8221 34.647 27.0943 34.3727 27.0943 34.0344C27.0943 33.6961 26.8221 33.4219 26.4863 33.4219C26.1505 33.4219 25.8783 33.6961 25.8783 34.0344C25.8783 34.3727 26.1505 34.647 26.4863 34.647Z",
    fill: "url(#paint12_linear_8678_28458)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1444 33.6181L26.0977 33.6621L26.8265 34.4468L26.8732 34.4027L26.1444 33.6181Z",
    fill: "url(#paint13_linear_8678_28458)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8991 33.6877L26.8553 33.6406L26.0765 34.3749L26.1202 34.422L26.8991 33.6877Z",
    fill: "url(#paint14_linear_8678_28458)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63473 34.8072C3.0589 34.8072 3.40275 34.4608 3.40275 34.0335C3.40275 33.6062 3.0589 33.2598 2.63473 33.2598C2.21056 33.2598 1.8667 33.6062 1.8667 34.0335C1.8667 34.4608 2.21056 34.8072 2.63473 34.8072Z",
    fill: "url(#paint15_linear_8678_28458)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63475 34.647C2.97056 34.647 3.24278 34.3727 3.24278 34.0344C3.24278 33.6961 2.97056 33.4219 2.63475 33.4219C2.29895 33.4219 2.02673 33.6961 2.02673 34.0344C2.02673 34.3727 2.29895 34.647 2.63475 34.647Z",
    fill: "url(#paint16_linear_8678_28458)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29661 33.6161L2.24988 33.6602L2.97873 34.4448L3.02546 34.4007L2.29661 33.6161Z",
    fill: "url(#paint17_linear_8678_28458)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04959 33.6936L3.00586 33.6465L2.22699 34.3807L2.27072 34.4278L3.04959 33.6936Z",
    fill: "url(#paint18_linear_8678_28458)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.121 36H0L4.49082 11.1761H6.32555V8.28537C6.32555 3.71821 10.0163 0 14.5605 0C16.7579 0 18.8273 0.870448 20.3847 2.42866C21.3234 3.38507 22.0381 4.56716 22.4221 5.84597L20.5341 6.44776C20.2354 5.4591 19.702 4.56716 18.9767 3.83642C17.8033 2.64358 16.2352 1.99881 14.5605 1.99881C11.1151 1.99881 8.30962 4.82507 8.30962 8.28537V11.1761H24.6302L29.121 36Z",
    fill: "#00ECB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8678_28458",
    x1: 14.4752,
    y1: 40.4167,
    x2: 15.3196,
    y2: -2.19199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8678_28458",
    x1: 14.5605,
    y1: 39.9872,
    x2: 14.5605,
    y2: 4.24509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8678_28458",
    x1: 14.3044,
    y1: -2.79423,
    x2: 14.1421,
    y2: 14.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8678_28458",
    x1: 7.25355,
    y1: 12.0467,
    x2: 7.2319,
    y2: 14.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8678_28458",
    x1: 7.25358,
    y1: 12.3807,
    x2: 7.23192,
    y2: 14.3473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8678_28458",
    x1: 6.65681,
    y1: 12.6629,
    x2: 7.82404,
    y2: 13.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8678_28458",
    x1: 7.88388,
    y1: 12.7335,
    x2: 6.6068,
    y2: 13.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8678_28458",
    x1: 21.3554,
    y1: 12.0467,
    x2: 21.3337,
    y2: 14.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8678_28458",
    x1: 21.3554,
    y1: 12.3807,
    x2: 21.3337,
    y2: 14.3473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8678_28458",
    x1: 20.7509,
    y1: 12.659,
    x2: 21.9255,
    y2: 13.9362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8678_28458",
    x1: 21.9786,
    y1: 12.7202,
    x2: 20.7009,
    y2: 13.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8678_28458",
    x1: 26.497,
    y1: 32.7654,
    x2: 26.4753,
    y2: 35.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8678_28458",
    x1: 26.497,
    y1: 33.0995,
    x2: 26.4753,
    y2: 35.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8678_28458",
    x1: 25.8956,
    y1: 33.3817,
    x2: 27.0701,
    y2: 34.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8678_28458",
    x1: 27.1264,
    y1: 33.4292,
    x2: 25.8566,
    y2: 34.5942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8678_28458",
    x1: 2.64539,
    y1: 32.7654,
    x2: 2.62374,
    y2: 35.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8678_28458",
    x1: 2.64542,
    y1: 33.0995,
    x2: 2.62377,
    y2: 35.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8678_28458",
    x1: 2.0478,
    y1: 33.3797,
    x2: 3.22237,
    y2: 34.6569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8678_28458",
    x1: 3.27696,
    y1: 33.4351,
    x2: 1.99926,
    y2: 34.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeable);
export default __webpack_public_path__ + "static/media/tradeable.48ab115275d153534638432cb374a5f4.svg";
export { ForwardRef as ReactComponent };